import {
  //Загрузка информации об опросе
  POLL_INFO_LOADING_START,
  POLL_INFO_LOADED_SUCCESSFULLY,
  POLL_INFO_LOADING_FAILED,
  //Удаление опроса
  POLL_VISIBILITY_CHANGE_START,
  POLL_VISIBILITY_CHANGED_SUCCESSFULLY,
  POLL_VISIBILITY_CHANGE_FAILED,
} from '../actions/pollInfo';

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  ready: false,
  loading: false,
  poll: {},
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    //Загрузка информации об опросе
    case POLL_INFO_LOADING_START:
      return {
        ...state,
        ready: false,
        loading: true,
        poll: {},
      };
    case POLL_INFO_LOADED_SUCCESSFULLY:
      //Свойство для управления чекбоксом
      //Поскольку просмотреть можно только видимый шаблон, всегда будет true
      //Второе условие написано на всякий случай
      const poll = action.payload.poll;
      poll.isVisible = true;
      if (poll.status === 'DISABLED') poll.isVisible = false;
      return {
        ...state,
        ready: true,
        loading: false,
        poll,
      };
    case POLL_INFO_LOADING_FAILED:
    case POLL_VISIBILITY_CHANGE_FAILED:
      return {
        ...state,
        ready: false,
        loading: false,
      };
    //Изменение видимости опроса
    case POLL_VISIBILITY_CHANGE_START:
      return {
        ...state,
        ready: false,
        loading: true,
      };
    case POLL_VISIBILITY_CHANGED_SUCCESSFULLY:
      return {
        ...state,
        ready: false,
        loading: false,
        poll: {},
      };
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}